import {
  administrative,
  declareFieldMeanings,
  identity,
  means,
} from '../../../src/issues/field-meanings';

/** What each detail of a 311 case means to an owner; the collector labels the feed's columns. */
export const fieldMeanings = declareFieldMeanings({
  sources: ['sf311'],
  declarations: [
    identity('address', 'Address', 'Street'),
    // Open311 enrichment is best effort and may be absent on a later read; its
    // description duplicates the request details, so neither coming nor going is news.
    administrative(
      'agency',
      'Responsible agency',
      'Source',
      'Latitude',
      'Longitude',
      'attributes',
      'description',
      'Updated',
      'updatedAt',
      'openedAt',
      'Opened',
      'closedAt',
      'Closed',
    ),
    means('status', 'the case status', ['status', 'Status']),
    means('description', 'the status note', ['statusNotes', 'Status notes'], {
      matters: 'said more about where the case stands',
      means:
        'This is the note the city attached to the case status. A change means the city said more about where the case stands.',
    }),
    means('description', 'the request details', ['details', 'Request details'], {
      matters: 'reworded what was reported',
      means: 'This is what was reported to 311. A change means the report was reworded.',
    }),
    means('detail', 'the case category', ['category', 'Category']),
    means('detail', 'the request type', ['subtype', 'Request type']),
    means('detail', 'the case photo', ['mediaUrl', 'Media URL'], {
      means:
        'This is the photo attached to the case. A change means a photo was added or replaced.',
    }),
  ],
});
